/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerFindOneQueryResponse, DepartmentsControllerFindOnePathParams, DepartmentsControllerFindOneQueryParams, DepartmentsControllerFindOne400, DepartmentsControllerFindOne401, DepartmentsControllerFindOne403, DepartmentsControllerFindOne404 } from "../../models/departmentsController/DepartmentsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { departmentsControllerFindOne } from "../../clients/departmentsService/departmentsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const departmentsControllerFindOneQueryKey = (id: DepartmentsControllerFindOnePathParams["id"], params: DepartmentsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/departments/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type DepartmentsControllerFindOneQueryKey = ReturnType<typeof departmentsControllerFindOneQueryKey>;
export function departmentsControllerFindOneQueryOptions(id: DepartmentsControllerFindOnePathParams["id"], params?: DepartmentsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = departmentsControllerFindOneQueryKey(id, params);
  return queryOptions<DepartmentsControllerFindOneQueryResponse, ResponseErrorConfig<DepartmentsControllerFindOne400 | DepartmentsControllerFindOne401 | DepartmentsControllerFindOne403 | DepartmentsControllerFindOne404>, DepartmentsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return departmentsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a department by ID
 * {@link /api/v1/departments/:id}
 */
export function useDepartmentsControllerFindOne<TData = DepartmentsControllerFindOneQueryResponse, TQueryData = DepartmentsControllerFindOneQueryResponse, TQueryKey extends QueryKey = DepartmentsControllerFindOneQueryKey>(id: DepartmentsControllerFindOnePathParams["id"], params?: DepartmentsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<DepartmentsControllerFindOneQueryResponse, ResponseErrorConfig<DepartmentsControllerFindOne400 | DepartmentsControllerFindOne401 | DepartmentsControllerFindOne403 | DepartmentsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? departmentsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...departmentsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DepartmentsControllerFindOne400 | DepartmentsControllerFindOne401 | DepartmentsControllerFindOne403 | DepartmentsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}